module.exports = __webpack_public_path__ + "img/banner2.c78927e9.png";